if (!customElements.get('shipping-estimator')) {
  class ShippingEstimator extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setupCountries();
      this.submitButton = this.querySelector('[type="button"]');
      this.submitButton.addEventListener('click', this.estimateShipping.bind(this));
      this.results = this.querySelector('.shipping-estimator--results');
    }

    async estimateShipping() {
      const zip = this.querySelector('.shipping-estimator-zip').value,
        country = this.querySelector('.shipping-estimator-country').value,
        province = this.querySelector('.shipping-estimator-province').value;

      this.submitButton.classList.add('loading');

      const response = await fetch(
        `${window.theme.routes.cart_url}/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`,
        { method: 'POST' }
      );

      if (response.ok) {
        const shippingRates = await this.getShippingRates(zip, country, province);
        this.formatShippingRates(shippingRates, country);
      } else {
        const jsonError = await response.json();
        this.formatError(jsonError);
      }
      this.submitButton.classList.remove('loading');
    }

    async getShippingRates(zip, country, province) {
      const response = await fetch(
        `${window.theme.routes.cart_url}/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`
      );
      const responseText = await response.text();
      if (responseText === 'null') {
        return this.getShippingRates(zip, country, province);
      } else {
        return JSON.parse(responseText).shipping_rates;
      }
    }

    /**
     * Format shipping rates with estimated delivery date from predefined array
     */
    formatShippingRates(shippingRates, country) {
      const countryDeliveryEstimates = {
        'United States': { min: 14, max: 17 },
        'Canada': { min: 12, max: 14 },
        'United Kingdom': { min: 4, max: 6 },
        'Germany': { min: 1, max: 3 },
        'Netherlands': { min: 1, max: 2 },
        'Switzerland': { min: 5, max: 6 },
        'Belgium': { min: 2, max: 3 },
        'France': { min: 3, max: 5 },
        'Austria': { min: 3, max: 5 },
        'Denmark': { min: 3, max: 4 },
        'Norway': { min: 10, max: 14 },
        'Sweden': { min: 4, max: 5 }
      };

      let formattedShippingRates = '',
        answer = '',
        format = window.theme.settings.money_with_currency_format || "${{amount}}";

      shippingRates.forEach((shippingRate) => {
        let estimate = countryDeliveryEstimates[country] || { min: 7, max: 15 }; // default fallback

        // Calculate delivery date range
        const today = new Date();
        const options = { weekday: 'short', month: 'short', day: 'numeric' };

        const minDate = new Date(today);
        minDate.setDate(today.getDate() + estimate.min);
        const maxDate = new Date(today);
        maxDate.setDate(today.getDate() + estimate.max);

        const formattedMinDate = minDate.toLocaleDateString('en-US', options);
        const formattedMaxDate = maxDate.toLocaleDateString('en-US', options);

        const deliveryRange = (estimate.min === estimate.max) ?
          `Estimated delivery: ${formattedMinDate}` :
          `Estimated delivery: ${formattedMinDate} - ${formattedMaxDate}`;

        formattedShippingRates += `
          <li>
            ${shippingRate.presentment_name}: ${formatMoney(parseFloat(shippingRate.price) * 100, format)}
            <br>${deliveryRange}
          </li>
        `;
      });

      if (shippingRates.length === 0) {
        answer = window.theme.strings.shippingEstimatorNoResults;
      } else if (shippingRates.length === 1) {
        answer = window.theme.strings.shippingEstimatorOneResult;
      } else {
        answer = window.theme.strings.shippingEstimatorMultipleResults;
      }

      const html = `
        <p>${answer}</p>
        ${formattedShippingRates === "" ? "" : `<ul>${formattedShippingRates}</ul>`}
      `;

      this.results.innerHTML = '';
      this.results.insertAdjacentHTML('beforeend', html);
    }

    formatError(errors) {
      let formattedShippingRates = '';
      Object.keys(errors).forEach((errorKey) => {
        formattedShippingRates += `<li>${errorKey} ${errors[errorKey]}</li>`;
      });
      const html = `
        <p>${window.theme.strings.shippingEstimatorError}</p>
        <ul>${formattedShippingRates}</ul>
      `;
      this.results.innerHTML = '';
      this.results.insertAdjacentHTML('beforeend', html);
    }

    setupCountries() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        let formId = this.dataset.formId;
        new Shopify.CountryProvinceSelector(`shipping-estimator-country-${formId}`, `shipping-estimator-province-${formId}`, {
          hideElement: `shipping-estimator-province-wrapper-${formId}`
        });
      }
    }
  }

  customElements.define('shipping-estimator', ShippingEstimator);
}
